export const hidenMessageAPI = [
  "user-preferences-general",
  "/api/jbf/institutions/",
  "/institutions",
];
